module.exports = __webpack_public_path__ + "img/coatesnhoff2020.a90e9f6d.png";